import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { OrderService } from "../../services/order/order.service";
import * as $ from "jquery";
import { EmitterVisitorContext } from "@angular/compiler";

@Component({
  selector: "main-nav",
  templateUrl: "./main-nav.component.html",
  styleUrls: ["./main-nav.component.scss"]
})
export class MainNavComponent implements OnInit, OnChanges {
  @Input() public bagIsActive: boolean;
  @Input() public isHome: boolean;
  @Input() public fullWidth: boolean;
  @Output() public bagOpenEvent: EventEmitter<any> = new EventEmitter();
  @Output() public routeChange: EventEmitter<any> = new EventEmitter();
  @Output() public openOnlineOrderingModal: EventEmitter<
    any
  > = new EventEmitter();

  public offsetNavIsActive: boolean = false;
  public orderLength;
  public scrolled;

  constructor(private _router: Router, private _orderService: OrderService) {}

  ngOnInit() {
    $(window).on("scroll", function() {
      if ($(window).scrollTop() >= 1) {
        $(".mobile-nav, .main-nav").addClass("fixed");
      } else {
        $(".mobile-nav, .main-nav").removeClass("fixed");
      }
    });

    this._orderService.getOrderLength().subscribe(length => {
      this.orderLength = length;
    });
  }

  fireRouteChange(e) {
    this.routeChange.emit({ url: this._router.url });
    this.offsetNavIsActive = false;
  }

  fireOpenOnlineOrderingModal(e) {
    this.openOnlineOrderingModal.emit({ open: true });
  }

  ngOnChanges() {
    // console.log('nav', this.isHome);
  }

  openBag(e) {
    if (!this.bagIsActive) {
      this.bagIsActive = true;
      this.bagOpenEvent.emit({ bagIsActive: this.bagIsActive });
    }
  }

  toggleOffCanvasNav() {
    this.offsetNavIsActive = !this.offsetNavIsActive;
    // console.log(this.offsetNavIsActive);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/main-nav/main-nav.component.ts